module.exports = __webpack_public_path__ + "img/estacion-metro.51ab94d9.svg";